import type { ResolvedHomeBlock } from '@conference/shared';

export interface HomeDataPlan {
  event: true;
  sessions: boolean;
  speakers: boolean;
  papers: boolean;
  exhibitors: boolean;
  announcements: boolean;
}

export function buildHomeDataPlan(blocks: ResolvedHomeBlock[]): HomeDataPlan {
  const has = (key: ResolvedHomeBlock['key']) => blocks.some((block) => block.key === key);
  return {
    event: true,
    sessions: has('happening_now') || has('up_next'),
    speakers: has('featured_speakers'),
    papers: has('featured_papers'),
    exhibitors: has('featured_exhibitors'),
    announcements: has('announcements'),
  };
}
